import React, { useEffect, useState } from 'react';
import { useMatch } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from '../state/hooks';
import { fetchOrders, fetchShipperDetails } from '../state/features/shipperDetailsSlice';
import { privateRoutes } from '../routes/appRouteList';
import { ApiStatus, EquipmentTypeCode } from '../utils/enums';
import { useFilters } from '../components/Filters/useFilters';
import BasePage from './Layouts/BasePage';
import PageHeader from './Layouts/PageHeader';
import PagePaper from './Layouts/PagePaper';
import PageContent from './Layouts/PageContent';
import PageFooter from './Layouts/PageFooter';
import ShipperDetailsHeader from '../components/Details/Headers/ShipperDetailsHeader';
import ShipperDetails from '../components/Details/ShipperDetails';
import OrderTable from '../components/Tables/OrderTable';

const ShipperDetailsPage = (): React.JSX.Element => {
    const dispatch = useAppDispatch();
    const filters = useFilters();
    const match = useMatch(privateRoutes.shipperDetails);

    const shipperId = match?.params.id;

    const [selectedEquipmentType, setSelectedEquipmentType] = useState(EquipmentTypeCode.VN);

    const ordersApiStatus = useAppSelector((state) => { return state.shipper.ordersApiStatus; });
    const orders = useAppSelector((state) => { return state.shipper.orders; });
    const orderCount = useAppSelector((state) => { return state.shipper.orderCount; });

    useEffect(() => {
        if (shipperId) {
            dispatch(fetchShipperDetails({
                filter_criteria: {
                    ...filters,
                    pickup_party_ids: [shipperId],
                },
            }));
        }
    }, [dispatch, shipperId, filters]);

    useEffect(() => {
        if (shipperId) {
            dispatch(fetchOrders({
                mri_freight_order_specified_eqpt_code: selectedEquipmentType,
                filter_criteria: {
                    ...filters,
                    pickup_party_ids: [shipperId],
                },
            }));
        }
    }, [dispatch, selectedEquipmentType, shipperId, filters]);

    return (
        <BasePage>
            <PagePaper>
                <PageHeader>
                    <ShipperDetailsHeader />
                </PageHeader>
                <PageContent>
                    <ShipperDetails />
                </PageContent>
                <PageFooter>
                    <OrderTable
                        isLoading={ordersApiStatus === ApiStatus.Idle || ordersApiStatus === ApiStatus.Loading}
                        orders={orders}
                        orderCount={orderCount}
                        equipmentType={selectedEquipmentType}
                        handleEquipmentTypeChange={(newEquipmentType): void => {
                            setSelectedEquipmentType(newEquipmentType);
                        }}
                    />
                </PageFooter>
            </PagePaper>
        </BasePage>
    );
};

export default ShipperDetailsPage;
